module.exports = __webpack_public_path__ + "static/assets/e35f839fed9160a1292e50b9c9943f6c.png";